import angular from "angular";

angular
    .module('app')
    .component('deleteForm', {
        template: require('./delete-form.html'),
        controller: ['$http', 'ErrorResponseParser', 'Notifier', '$scope', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, ErrorResponseParser, Notifier, $scope) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.item = $ctrl.resolve.item;
        $ctrl.type = $ctrl.resolve.type;
    };

    $ctrl.submit = function () {

        let req = null;
        let params = {
            item_id: $ctrl.item.id,
            type: $ctrl.type,
        };

        params['_method'] = 'delete';
        req = $http.delete(`/admin/${$ctrl.type}/${$ctrl.item.id}`, params);

        req.then(
            function (response) {
                $ctrl.close({$value: response});
            },
            function (error) {
                $ctrl.close({$value: error});
                ErrorResponseParser.parse(error);
            }
        );


    }

}